import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { PublishSectionModalDispatchParams, publishSectionModalSlice, PublishSectionModalState } from '@REDUCERS';

function createPublishSectionModalHook() {
    return function usePublishSectionModal(equalityFn?: EqualityFn<PublishSectionModalState>) {
        const state = useAppSelector((store) => store.publishSectionModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: PublishSectionModalDispatchParams) => dispatch(publishSectionModalSlice.actions.open(params)),
            close: () => dispatch(publishSectionModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createPublishSectionModalHook();
